import { render, staticRenderFns } from "./Grades.vue?vue&type=template&id=519271f7&scoped=true"
import script from "./Grades.vue?vue&type=script&lang=js"
export * from "./Grades.vue?vue&type=script&lang=js"
import style0 from "./Grades.vue?vue&type=style&index=0&id=519271f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519271f7",
  null
  
)

export default component.exports